module.exports = __webpack_public_path__ + "static/media/transformative-logo-reverse.f82537a6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/transformative-logo-reverse.svg
// module id = 552
// module chunks = 3